import React from 'react';
import moment from 'moment'

import { popUpClose } from '../../actions/pop-ups';
import { userUpdated } from '../../actions/user';
import AccountSwitcher from '../user/account-switcher';

import { useDispatch } from 'react-redux';

export default function ViewUser({
  name,
  email,
  account_type,
  manual_plan,
  created_at,
  confirmed,
  last_sign_in_at,
  sign_in_count,
  subscription,
  free_trial_expired,
  free_trial_expires_at
}){
  const dispatch = useDispatch();
  let plans = [
    'Starter',
    'One Month',
    'Monthly Premium',
    'Yearly Premium'
  ];

  return(
    <div className="modal">
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <button
              type="button"
              className="close"
              aria-hidden="true"
              onClick={(e) => {
                e.preventDefault()
                dispatch( popUpClose() )
              }}
            >&times;</button>
            <h4 className="modal-title">User</h4>
          </div>
          <div className="modal-body">
            <div className="crud-form__container user-view-table">
              <table width="100%" className="pure-table pure-table-horizontal pure-table-striped">
                <tbody>
                  <tr>
                    <td><strong>Name:</strong></td>
                    <td>{name}</td>
                  </tr>
                  <tr>
                    <td><strong>Email:</strong></td>
                    <td><a href={'mailto:' + email}>{email}</a></td>
                  </tr>

                  <tr>
                    <td>
                      <strong>Account Type:</strong>
                    </td>
                    <td>
                      <AccountSwitcher email={email} current={account_type} plans={plans} onChanged={(user) => dispatch( userUpdated(user) )} />
                    </td>
                  </tr>
                  {
                    manual_plan ? (
                      <tr>
                        <td><strong>Plan set manually:</strong></td>
                        <td>
                          by {manual_plan.set_by || 'an admin'}
                          {manual_plan.set_at ? ' on ' + moment(manual_plan.set_at).format('D MMM YYYY') : ''}
                          {manual_plan.note ? ' (' + manual_plan.note + ')' : ''}.
                          {' '}Braintree won't downgrade it; a successful payment hands it back to Braintree.
                        </td>
                      </tr>
                    ) : null
                  }
                  {
                    subscription ? (
                      <React.Fragment>
                        <tr>
                          <td><strong>Subscription status:</strong></td>
                          <td>
                              <span className="subscription-status">{subscription.status}</span>
                        </td>
                        </tr>
                        <tr>
                          <td><strong>Payment method</strong></td>
                          <td>
                              <img src={subscription.payment_method.image_url} alt="payment method symbol"/>
                          </td>
                        </tr>
                        <tr>
                          <td><strong>Last Transaction</strong></td>
                          <td>
                            <span className="">£{ subscription.latest_transaction.amount } ({ subscription.latest_transaction.status })</span>
                          </td>
                        </tr>
                        <tr>
                          <td><strong>Next billing date</strong></td>
                          <td>
                            <span className="">{ subscription.next_billing_date }</span>
                          </td>
                        </tr>
                        <tr>
                          <td><strong>Next billing amount</strong></td>
                          <td>
                            <span className="">£{ subscription.next_billing_period_amount }</span>
                          </td>
                        </tr>
                      </React.Fragment>
                    ): null
                  }
                  <tr>
                    <td><strong>Date Joined:</strong></td>
                    <td>{moment(created_at).format('MMMM Do YYYY')}</td>
                  </tr>


                  {
                    (account_type == "Starter") ? (
                      <React.Fragment>
                      <tr>
                        <td><strong>Free trial expiry date</strong></td>
                        <td>{moment(free_trial_expires_at).format('MMMM Do YYYY')}</td>
                      </tr>
                      <tr>
                        <td><strong>Free trial expired?</strong></td>
                        <td>{free_trial_expired ? 'Yes' : 'No'}</td>
                      </tr>
                      </React.Fragment>
                    ) : null
                  }

                  <tr>
                    <td><strong>Confirmed Account:</strong></td>
                    <td>{confirmed ? 'Yes' : 'No'}</td>
                  </tr>
                  <tr>
                    <td><strong>Last signed in:</strong></td>
                    <td>{ last_sign_in_at ? moment(last_sign_in_at).fromNow() : 'Never'}</td>
                  </tr>
                  <tr>
                    <td><strong>Sign in count:</strong></td>
                    <td>{sign_in_count}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div className="modal-footer">
            <button
              onClick={(e) => {
                e.preventDefault();
                dispatch( popUpClose() )
              }}
              className="btn button-cancel pure-button"
            >Close</button>
          </div>
        </div>
      </div>
    </div>
  )
}
